import type { FieldType } from './base.js';

export const hiddenType: FieldType = {
  render(ctx) {
    let input = ctx.host.querySelector<HTMLInputElement>(':scope > input[type="hidden"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      ctx.host.appendChild(input);
    }
    input.name = ctx.name;
    input.value = ctx.host.getAttribute('value') ?? ctx.defaultValue ?? '';
    // Скрытые поля не должны занимать место в потоке
    ctx.host.style.display = 'none';
  },

  getValue(ctx) {
    return ctx.host.querySelector<HTMLInputElement>(':scope > input[type="hidden"]')?.value ?? '';
  },

  validate() {
    return { valid: true };
  },

  shouldSubmit() {
    return true;
  },

  setDisabled() {
    /* hidden поля не блокируем */
  },
};
